// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;


const isConfigValid = !!SUPABASE_URL && !!SUPABASE_PUBLISHABLE_KEY;

if (!isConfigValid) {
  console.error("Supabase configuration is missing. Checked VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY (or legacy VITE_SUPABASE_ANON_KEY)");
}

// Proxy to throw errors on usage rather than initialization if config is missing
const safeClientHandler = {
  get: function (target: object, prop: string | symbol) {
    if (!isConfigValid) {
      throw new Error(`Supabase configuration missing. Cannot access '${String(prop)}'. Check environment variables.`);
    }
    return Reflect.get(target, prop);
  }
};

const internalClient = isConfigValid
  ? createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: window.localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    }
  })
  : {} as unknown as ReturnType<typeof createClient<Database>>; // Empty object if invalid, handled by proxy

export const supabase = new Proxy(internalClient, safeClientHandler) as unknown as ReturnType<typeof createClient<Database>>;